import type { ReactNode } from 'react';
import {
  parseCardMarkdown,
  type CardMarkdownNode,
} from '../../shared/card-markdown.ts';

function renderNode(
  node: CardMarkdownNode,
  key: string,
  links: 'allow' | 'text',
): ReactNode {
  if (node.type === 'text') return node.value;
  if (node.type === 'code') return <code key={key}>{node.value}</code>;
  if (node.type === 'break') return <br key={key} />;
  const children = node.children.map((child, index) =>
    renderNode(child, `${key}-${index}`, links),
  );
  if (node.type === 'strong') return <strong key={key}>{children}</strong>;
  if (node.type === 'em') return <em key={key}>{children}</em>;
  if (node.type === 'underline') return <u key={key}>{children}</u>;
  if (node.type !== 'link' || links === 'text') return children;
  return (
    <a href={node.href} key={key} rel="noreferrer" target="_blank">
      {children}
    </a>
  );
}

export function CardMarkdown({
  links = 'allow',
  source,
}: {
  links?: 'allow' | 'text';
  source: string;
}) {
  return (
    <>
      {parseCardMarkdown(source).map((node, index) =>
        renderNode(node, String(index), links),
      )}
    </>
  );
}
